import { render, staticRenderFns } from "./Recordings.vue?vue&type=template&id=a9985584&scoped=true&"
import script from "./Recordings.vue?vue&type=script&lang=js&"
export * from "./Recordings.vue?vue&type=script&lang=js&"
import style0 from "./Recordings.vue?vue&type=style&index=0&id=a9985584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9985584",
  null
  
)

export default component.exports